import { Component, ViewChild } from "@angular/core";
import { ICellRendererAngularComp } from 'ag-grid-angular';
import { IDropdownItem } from "@irb-common/models/dropdown.model";
import {DropdownFilterComponent} from "@irb-common/components/dropdown-filter/dropdown-filter.component";

@Component({ standalone: false,
  selector: "irb-dropdown-filter-cell",
  template: ` <irb-dropdown-filter #dropdownFilter [(value)]="value" [size]="size" [hoverPanelWidth]="hoverPanelWidth" (search)="populateDropdown($event)" (selection)="onSelect($event)" (clearSelection)="onClearSelection()" (keydown)="$event.stopPropagation()" [placeholder]="placeholder" [disabled]="disabled" [addNewItem]="addNewItem" (openNewItemFlow)="openNewItemFlow($event)"></irb-dropdown-filter> `,
})
export class DropdownFilterRendererComponent implements ICellRendererAngularComp {
  @ViewChild("dropdownFilter") dropdownFilter: any;

  params: any;
  value: IDropdownItem;
  isNotApplicable: boolean;
  readonly: boolean;
  placeholder: string;
  size: number;
  hoverPanelWidth: number;
  disabled: boolean;
  addNewItem: any = null;

  constructor() {}

  agInit(params: any) {
    this.params = params;
    this.value = typeof this.params.defaultValue !== "undefined" ? this.params.defaultValue : null;
    this.isNotApplicable = (typeof this.params.isNotApplicable !== "undefined") ? this.params.isNotApplicable : false;
    this.readonly = typeof this.params.readonly !== "undefined" ? this.params.readonly : false;
    this.placeholder = typeof this.params.placeholder !== "undefined" ? this.params.placeholder : "-Select-";
    this.size = (typeof this.params.size !== "undefined") ? this.params.size : 25;
    this.hoverPanelWidth = (typeof this.params.hoverPanelWidth !== "undefined") ? this.params.hoverPanelWidth : 300;
    this.params.disabled = (typeof this.params.isDisabled !== "undefined") ? this.params.isDisabled : this.params.disabled;
    this.disabled = (typeof this.params.disabled !== "undefined") ? this.params.disabled : false;
    this.addNewItem = this.params.addNewItemConfig || null;

    if (this.isNotApplicable) {
      this.value = {
        name: "n/a",
        value: null,
      };
    }
  }

  refresh(): boolean {
    return true;
  }

  populateDropdown(searchString: string): void {
    // if (this.readonly) {
    //   this.dropdownFilter.set(this.params.values || []);
    // } else {
    //   const f = DropdownFilterComponent.getFilteredList(searchString, this.params.values);
    //   this.dropdownFilter.set(f);
    // }
    if (this.params.componentParent && this.params.values.length === 0 && this.params.colId)
      this.params.values = this.params.componentParent.getListOfValues(this.params.colId);
    this.dropdownFilter.set(DropdownFilterComponent.getFilteredList(searchString, this.params.values));
  }

  onSelect(itemSelected: IDropdownItem): void {
    this.value = itemSelected;

    if (this.params.onChange) {
      this.params.onChange(this.params, this.value);
    }
  }

  onClearSelection(): void {
    if (this.params.onClearSelection) {
      this.params.onClearSelection(this.params);
    }
  }

  openNewItemFlow(event: any) {
    if (this.params.openNewItemFlow) {
      this.params.openNewItemFlow(event);
    }
  }
}
